export const complianceLawsList = ['CCPA', 'GDPR']
